/** @format */

import { createReducer } from "@reduxjs/toolkit";
import { IPerson } from "lobbie";
import { EUserType } from "src/constants/user";
import { includesSuperAdminRoleGroup, isEmptyObject, setUserStorage } from "src/utils";
import { setUser } from "../actions/userActions";

export type UserReducerState = {
    user?: IPerson & { roleGroupIds?: string };
};
const initialState: UserReducerState = {};

export const userReducer = createReducer(initialState, (builder) => {
    return builder.addCase(setUser, (state, action) => {
        if (action?.payload && !isEmptyObject(action.payload)) {
            const userType = (() => {
                if (includesSuperAdminRoleGroup(action.payload.roleGroupIds)) {
                    return EUserType.SuperAdmin;
                } else if ("isPatient" in action.payload && !action.payload.isPatient) {
                    return EUserType.Staff;
                } else {
                    return EUserType.Patient;
                }
            })();

            setUserStorage(action.payload.id, userType);
        }
        return {
            ...state,
            user: action?.payload, // TODO: this is probably being mistakenly set under the assumption that `state` refers to the root application state when instead it is the reducer state which in effect results in `state.user.user` at the root level
        };
    });
});
